module.exports = __webpack_public_path__ + "static/media/dots-menu.faa47cd3.svg";